export const CH31_FETCH_STARTED = 'CH31_FETCH_STARTED';
export const CH31_FETCH_SUCCEEDED = 'CH31_FETCH_SUCCEEDED';
export const CH31_FETCH_FAILED = 'CH31_FETCH_FAILED';

export const CH31_ERROR_400_BAD_REQUEST = 'CH31_ERROR_400_BAD_REQUEST';
export const CH31_ERROR_403_FORBIDDEN = 'CH31_ERROR_403_FORBIDDEN';
export const CH31_ERROR_500_SERVER = 'CH31_ERROR_500_SERVER';
export const CH31_ERROR_503_UNAVAILABLE = 'CH31_ERROR_503_UNAVAILABLE';
